<template>
	<div class="tableWrap">
		<div class="head">
			<span @click="goBack" class="back">
				<i>&nbsp;</i>返回</span>
			<span class="mx">BU奖金明细</span>
			<p class="select">
				<span>年份：</span>
				<el-select class="top-choose" v-model="year" clearable placeholder="请选择">
					<el-option v-for="item in bonusYearOptions" :key="item" :value="item">
					</el-option>
				</el-select>
				<span>周期：</span>
				<el-select class="top-choose" v-model="cycleId" clearable placeholder="请选择" z-noData-text="请先选择年份">
					<el-option v-for="item in bonusCycleOptions" :key="item.id" :label="item.cycle_number_show" :value="item.id" >
					</el-option>
				</el-select>
				<!-- <span>快币类型：</span>
				<el-select class="top-choose" v-model="currencyId" clearable placeholder="请选择">
					<el-option v-for="item in currencyList" :key="item.id"  :value="item.id" :label="item.currency_name" >
					</el-option>
				</el-select> -->
				<el-button type="primary" style="margin-left:20px;" @click="search()" >查询</el-button>
			</p>
		</div>

		<div class="table-main">
			<div class="main-head">
				<div>日期</div>
				<div>周期</div>
				<!-- <div>快币类型</div> -->
				<div>奖金收支({{ task_curr.currency_name }})</div>
				<div>奖金余额({{ task_curr.currency_name }})</div>
				<div>详情</div>
			</div>
			<z-scrollDiv class="main-wrap">
				<div class="main-item" v-for="item in dataList" :key="item.id">
					<div>{{ item.bill_time }}</div>
					<div>{{ item | cycleStr }}</div>
					<!-- <div class="overhide" :title="item.currency_name">{{ item.currency_name }}</div> -->
					<div :class="{add:item.bill_type == 1,reduce:item.bill_type!=1}">{{ calcStr(item) }}</div>
					<div>{{ item.balance }}</div>
					<div class="overhide" :title="item.remark">{{ item.remark }}</div>
				</div>
				<z-noData :list="dataList"></z-noData>
			</z-scrollDiv>
		</div>

		<z-pagination @getPage="search" :data='data'></z-pagination>
	</div>
</template>

<script type="text/ecmascript-6">
	import { mapGetters, mapState } from 'vuex'
	import { getBonusCycleOptions } from "src/control/common.js";


	export default {
		data() {
			return {
				year:"",  //选项  年
				cycleId:"",  //选项 周期
				// currencyId:"",  //选项 快币类型

				bonusCycleOptions:[],  // 周期选项
				data:{},   //奖金明细数据
			}
		},
		computed: {
			...mapState(["currencyList"]),  //快币列表
			...mapGetters(["bonusYearOptions","task_curr"]),  //周期年份列表
			
			dataList(){
				return this.data.list;
			},
			
		},
		watch:{
			year(val){
				this.bonusCycleOptions = getBonusCycleOptions(val);
                this.cycleId = "";
			},
		},
		created(){
			this.refresh();
			this.$func.getBonusCycle(true);  //获取周期情况
		},
		methods: {
			goBack: function () {  //返回
				this.$router.push({
					name:'info-money',
				});
			},
			refresh(obj={}){  //拉数据
				let url = "api/manager/curr_dist_detail";
				this.$http.get(url,{params:obj}).then(res=>{
					if(res.status == 200){
						this.data = res.res_data;
					}
				});
			},
			search(page){  //搜索
				let obj={
					page:page,
					cycle_year:this.year,
					cycle_detail_id:this.cycleId,
					// currency_id:this.currencyId,
				}
				this.refresh(obj);
			},
			calcStr(item){   //拼接奖金数额
				let operator = item.bill_type == 1?"+":"-";
				let num = item.trans_amount;
				return operator+num;
			},

		},

	}
</script>

<style lang="less" scoped>
	@import "~src/assets/less/asset-detail.less";
	// **************
	.main-head,.main-item{
		>div{
			&:nth-of-type(1){width:15%;}
			&:nth-of-type(2){
				width:15%;
				// text-align: center;
			}
			&:nth-of-type(3){
				width:15%;
				// text-align: center;
			}
			&:nth-of-type(4){
				width:15%;
				// text-align: center;
			}
			&:nth-of-type(5){max-width:40%;}
		}
	}
</style>



// WEBPACK FOOTER //
// page-bonusTable.vue?288bc9d0